import React, { Component } from 'react';
import Input from './Input';
import Select from './Select';
import ButtonGroup from './ButtonGroup';
import blankConfig from '../assets/images/global/blank-config.png';

class ConfigurationGroup extends Component {
		constructor(props) {
				super(props);

				this.state = {
					hideAddButton: false,
					seakeeperData: [
						{
							seakeeperModel: '',
							numGyros: ''
						}
					]
				}

				this.addSeakeeper = this.addSeakeeper.bind(this);
				this.changeModel = this.changeModel.bind(this);
				this.changeNumberGyros = this.changeNumberGyros.bind(this);
				this.incrementGyros = this.incrementGyros.bind(this);
				this.decrementGyros = this.decrementGyros.bind(this);
				this.deleteModel = this.deleteModel.bind(this);
				this.deleteConfiguration = this.deleteConfiguration.bind(this);
				this.recommendConfiguration = this.recommendConfiguration.bind(this);
				this.changeShowHide = this.changeShowHide.bind(this);
		}

		addSeakeeper () {
				let seakeeperData = this.state.seakeeperData,
					numSeakeepers = seakeeperData.length,
					hideAddButton = false;

				if (numSeakeepers < 3) {

					if ((numSeakeepers + 1) == 3) {
						hideAddButton = true;
					}

					this.setState({
						hideAddButton: hideAddButton
					})

					const configIndex = this.props.configIndex;
					this.props.addSeakeeper(configIndex);
				}
		}

		changeModel(e) {
			let model = e.target.value * 1;
			let targetName = e.target.name;
			let skIndex = targetName.split("_")[2];
			let tempSeakeeperData = this.state.seakeeperData;

			const configIndex = this.props.configIndex;
			let data = {
				"key": "seakeeperModel",
				"value": model
			};

			this.props.onChange(configIndex, skIndex, data);
		}

		changeNumberGyros(e) {
			let numGyros = e.target.value * 1;
			let targetName = e.target.name;
			let skIndex = targetName.split("_")[2];
			let tempSeakeeperData = this.state.seakeeperData;
			const configIndex = this.props.configIndex;

			if (!Number.isInteger(numGyros)) {
				numGyros = 0;
			}

			if (numGyros > 99) {
				numGyros = 99;
			} else if (numGyros < 0) {
				numGyros = 0;
			}

			let data = {
				"key": "numGyros",
				"value": numGyros
			};

			this.props.onChange(configIndex, skIndex, data);
		}

		incrementGyros(e) {
			let target = e.target;
			let skIndex = target.dataset.skindex;
			const configIndex = this.props.configIndex;
			let curNumGyros = this.props.seakeeperData[skIndex].numGyros * 1;
			let newNumGyros = curNumGyros + 1;
			if (newNumGyros > 99) {
				newNumGyros = 99;
			}
			let data = {
				"key": "numGyros",
				"value": newNumGyros
			};
			this.props.onChange(configIndex, skIndex, data);
		}

		decrementGyros(e) {
			let target = e.target;
			let skIndex = target.dataset.skindex;
			const configIndex = this.props.configIndex;
			let curNumGyros = this.props.seakeeperData[skIndex].numGyros * 1;
			let newNumGyros = curNumGyros - 1;
			if (newNumGyros < 0) {
				newNumGyros = 0;
			}
			let data = {
				"key": "numGyros",
				"value": newNumGyros
			};
			this.props.onChange(configIndex, skIndex, data);
		}

		deleteModel(e) {
			let target = e.target;
			let skIndex = target.dataset.skindex;
			const configIndex = this.props.configIndex;
			this.props.deleteModel(configIndex, skIndex);
		}

		deleteConfiguration() {
			const configIndex = this.props.configIndex;
			this.props.deleteConfiguration(configIndex);
		}

		recommendConfiguration() {
			const configID = this.props.configID;
			this.props.updateRecommendConfig(configID);
		}

		changeShowHide(value) {
			const configIndex = this.props.configIndex;
			this.props.changeShowHide(configIndex, value);
		}

		render() {
				const { hideAddButton } = this.state;
				const { seakeeperList = [], configIndex, seakeeperData } = this.props;

				// convert lists to option lists for select element
				let seakeeperOptions = [],
					seakeeperImages = [],
					seakeeperImagesGroup = [];

				for(let i=0; i<seakeeperList.length; i++) {
					seakeeperOptions.push({
						value: seakeeperList[i].seakeeper_id,
						text: seakeeperList[i].seakeeper_model
					});
					seakeeperImages[seakeeperList[i].seakeeper_id] = (
						<img
							src={'https://api.seakeeper.com/' + seakeeperList[i].image_url}
							className="pp-seakeeper-image"
							data-id={seakeeperList[i].seakeeper_id}
						/>
					);
				}
				// Add seakeeper silhouette image
				seakeeperImages.push(
					<img
						src={blankConfig}
						className="pp-seakeeper-image pp-show"
					/>
				);

				for (let a = 0; a < seakeeperData.length; a += 1) {
					let temp = seakeeperImages.slice(0),
						model = seakeeperData[a].seakeeperModel;
					if (model !== "" && temp[model]) {
						temp[model] = <img
							src={temp[model].props.src}
							className="pp-seakeeper-image pp-show"
							data-id={temp[model].props['data-id']}
						/>
						temp.pop(); // Removes seakeeper silhouette image
					}
					seakeeperImagesGroup.push(temp);
				}

				return (
						<div className="pp-configuration-group">
								<div className="pp-group-header">
									<h4 className="pp-config-title">Configuration {this.props.order + 1}
										{(this.props.isRecommended == "true") ? <span className="pp-recommend-callout"> - Recommended Seakeeper Configuration</span> : ''}
									</h4>
									{this.props.canShowHide && (this.props.isRecommended !== "true") &&
										<div className="pp-include-config">
											<p>Include in Report?</p>
											<ButtonGroup
												className="pp-show-in-report"
												options={['Include', 'Exclude']}
												selected={(this.props.showConfig === "1" || this.props.showConfig === 1) ? 0 : 1}
												value={'Include'}
												onChange={this.changeShowHide}
											/>
										</div>
									}
									{this.props.canRecommend && this.props.disableAll &&
										<button className="pp-recommend-configuration" onClick={this.recommendConfiguration}>Recommend Configuration</button>
									}
									{!this.props.disableAll &&
										<button className="pp-delete-configuration" onClick={this.deleteConfiguration}>Delete Configuration</button>
									}
								</div>

								{seakeeperData &&
									seakeeperData.map((data, index) => (
										<div className="pp-config-field-group" key={index}>
											<div className="pp-seakeeper-display">
												{seakeeperImagesGroup[index]}
											</div>
											<Select
												label="Seakeeper"
												htmlName={"seakeeperModel_" + configIndex + "_" + index}
												value={data.seakeeperModel || ""}
												placeholderText="a Model"
												options={seakeeperOptions}
												onChange={this.changeModel}
												disabled={this.props.disableAll}
											/>
											<div className="pp-input-controls">
												<label className="pp-input-label">Quantity</label>
												{!this.props.disableAll &&
													<button
														type="button"
														className="pp-input-decrement"
														onClick={this.decrementGyros}
														data-skindex={index}>-</button>
												}
												<Input
													type="text"
													htmlName={"numGyros_" + configIndex + "_" + index}
													value={data.numGyros || ""}
													placeholderText="0"
													onChange={this.changeNumberGyros}
													disabled={this.props.disableAll}
												/>
												{!this.props.disableAll &&
													<button
														type="button"
														className="pp-input-increment"
														onClick={this.incrementGyros}
														data-skindex={index}>+</button>
												}
											</div>
											{!this.props.disableAll &&
												<button
													className="pp-delete-group"
													onClick={this.deleteModel}
													data-skindex={index}>
													<span className="pp-button-text">Delete Model</span>
												</button>
											}
										</div>
									))
								}
								{(!this.props.disableAddSeakeeper && !this.props.disableAll) &&
									<button className="pp-add-seakeeper" onClick={this.addSeakeeper}>Add Additional <br />Seakeeper Model</button>
								}
						</div>
				);
		}
}

export default ConfigurationGroup;



// WEBPACK FOOTER //
// ./src/components/ConfigurationGroup.js